import { motion } from 'framer-motion';
import { Shortcut, Text, useIsListBoxItemSelected } from '@frameio/vapor';
import {
  IconMagnifyingglass,
  IconMagnifyingglassAiSparkle,
} from '@frameio/vapor-icons';
import { GLPYHS } from '../../../constants/Glyphs';
import styles from './AdvancedSearchItem.module.css';
import TEXT from './generated/TEXT/AdvancedSearchItemCompact';

TEXT.DEFINE({
  title: 'Show all results for',
  titleAi: 'AI Search',
});

type AdvancedSearchItemProps = {
  isAiSearch?: boolean;
  isAppleOs?: boolean;
  onClick: () => void;
  searchQuery: string;
};

export const AdvancedSearchItem = ({
  isAiSearch = false,
  isAppleOs = false,
  onClick,
  searchQuery,
}: AdvancedSearchItemProps) => {
  const isActive = useIsListBoxItemSelected();
  const SearchIcon = isAiSearch
    ? IconMagnifyingglassAiSparkle
    : IconMagnifyingglass;

  return (
    <motion.div
      className={styles.advancedSearchItem}
      layout="position"
      onClick={onClick}
    >
      <div className={styles.row} data-active={isActive}>
        <div className={styles.text}>
          <span className={styles.textIcon}>
            <SearchIcon
              color={
                isActive
                  ? 'var(--colors-icon-interactive-selected)'
                  : 'var(--colors-icon-secondary)'
              }
            />
            <Text color={isActive ? 'primary' : 'secondary'} variant="body">
              {isAiSearch ? TEXT.titleAi : TEXT.title}:
            </Text>
          </span>
          <Text
            className={styles.queryText}
            color={isActive ? 'primary' : 'body'}
            fontWeight="medium"
            truncate={true}
            variant="body"
          >
            {searchQuery}
          </Text>
        </div>
        <div className={styles.shortcut}>
          {!isActive && !isAiSearch && (
            <Shortcut type="neverBeenUsed">
              {isAppleOs ? GLPYHS.command : GLPYHS.control}
            </Shortcut>
          )}
          {((isActive && isAiSearch) || !isAiSearch) && (
            <Shortcut type={isActive ? 'hasBeenUsed' : 'neverBeenUsed'}>
              {GLPYHS.enter}
            </Shortcut>
          )}
        </div>
      </div>
    </motion.div>
  );
};
